var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedHotelListing(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42871 6H4.88574V7.97902C5.02104 7.94176 5.16354 7.92186 5.31069 7.92186H6.93346C7.81532 7.92186 8.53028 8.63673 8.53028 9.51865V10.1953H16.5279C17.7028 10.1953 18.6553 11.1477 18.6553 12.3226V13.0664L19.5459 13.0664V18.5827H18.374V16.5112H2.60059V18.5827H1.42871V6ZM2.60059 14.2383V15.3393H18.374V14.2383L2.60059 14.2383ZM17.4834 13.0664V12.3226C17.4834 11.7949 17.0556 11.3671 16.5279 11.3671L4.88574 11.3671V13.0664L17.4834 13.0664ZM3.71387 13.0664V7.17187H2.60059V13.0664H3.71387ZM4.88574 10.1953L7.35841 10.1952V9.51865C7.35841 9.284 7.16817 9.09374 6.93346 9.09374H5.31069C5.07596 9.09374 4.88574 9.28398 4.88574 9.51865L4.88574 10.1953Z",
    fill: "#FE4747"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedHotelListing);
export default __webpack_public_path__ + "static/media/bed_hotel_listing.a3902c5256c5be63745ca9a9b4787f0e.svg";
export { ForwardRef as ReactComponent };